import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserService } from '@services/core/user.service';
import { map } from 'rxjs/operators';

export const rolesResolver: ResolveFn<any> = () => {
  const userService = inject(UserService)

  return userService.getRoles().pipe(
    map(roles => ({ roles }))
  )
}
